import http from './public'
// 商品列表
export const getAllGoods = (params) => {
  return http.fetchGet('/picSearch/wes/product/allGoods', params)

  // return http.fetchGet('/front/goods/allGoods', params)
}

export const getMyOrder = (params) => {
  return http.fetchPost('/picSearch/wes/product/myOrder', params)
  // return http.fetchGet('/front/goods/allGoods', params)
}
export const getMyGarmentOrder = (params) => {
  return http.fetchPost('/picSearch/wes//cloth/noticeDetail/listToGetstepTimes', params)
  // return http.fetchGet('/front/goods/allGoods', params)
}

export const getProductIdByCode = (params) => {
  return http.fetchPost('/picSearch/wes/product/getProductIdByCode', params)
  // return http.fetchGet('/front/goods/allGoods', params)
}

export const getMyLapDip = (params) => {
  return http.fetchPost('/picSearch/wes/product/myLapDip', params)
  // return http.fetchGet('/front/goods/allGoods', params)
}
export const getMySample = (params) => {
  return http.fetchPost('/picSearch/wes/product/mySample', params)
  // return http.fetchGet('/front/goods/allGoods', params)
}
// 获取购物车列表
export const getCartList = (params) => {
  return http.fetchPost('/picSearch/wes/cart/cartList', params)
}

// 加入购物车
export const addCart = (params) => {
  return http.fetchPost('/picSearch/wes/cart/addCart', params)
}
// 修改购物车分组
export const editGroup = (params) => {
  return http.fetchPost('/picSearch/wes/cart/editGroup', params)
}
// 删除购物车
export const delCart = (params) => {
  return http.fetchPost('/picSearch/wes/cart/delCart', params)
}
// 删除购物车勾选商品
export const delCartChecked = (params) => {
  return http.fetchPost('/picSearch/wes/cart/delCartChecked', params)
}
// 编辑购物车
export const cartEdit = (params) => {
  return http.fetchPost('/picSearch/wes/cart/cartEdit', params)
}
// 全选
export const editCheckAll = (params) => {
  return http.fetchPost('/picSearch/wes/cart/editCheckAll', params)
}
// 删除整条购物车
export const cartDel = (params) => {
  return http.fetchPost('/picSearch/wes/cart/cartDel', params)
}

// // 获取购物车列表
// export const getCartList = (params) => {
//   return http.fetchPost('/front/member/cartList', params)
// }

// 获取用户地址
export const addressList = (params) => {
  return http.fetchPost('/front/member/addressList', params)
}
// 通过id获取地址
export const getAddress = (params) => {
  return http.fetchPost('/front/member/address', params)
}
// 修改收货地址
export const addressUpdate = (params) => {
  return http.fetchPost('/front/member/updateAddress', params)
}
// 添加收货地址
export const addressAdd = (params) => {
  return http.fetchPost('/front/member/addAddress', params)
}
// 删除收货地址
export const addressDel = (params) => {
  return http.fetchPost('/front/member/delAddress', params)
}
// 生成订单
export const submitOrder = (params) => {
  return http.fetchPost('/front/member/addOrder', params)
}
// 支付
export const payMent = (params) => {
  return http.fetchPost('/front/member/payOrder', params)
}
// 获取用户订单
export const orderList = (params) => {
  return http.fetchGet('/front/member/orderList', params)
}

// 获取单个订单详情
export const getOrderDet = (params) => {
  return http.fetchGet('/front/member/orderDetail', params)
}
// 取消订单
export const cancelOrder = (params) => {
  return http.fetchPost('/front/member/cancelOrder', params)
}
// 商品详情
export const productDet = (params) => {
  return http.fetchGet('/picSearch/wes/product/productDet', params)
}
// 新增浏览历史
export const addBrowse = (params) => {
  return http.fetchPost('/picSearch/wes/product-browse-log/insertBrowseLog', params)
}

// 新增浏览历史
export const errprReport = (params) => {
  return http.fetchPost('/picSearch/wes/errorReport/create', params)
}

export const getCusromerBrowseLog = (params) => {
  return http.fetchPost('/picSearch/wes/product-browse-log/getCusromerBrowseLog', params)
}

export const getMyFabric = (params) => {
  return http.fetchPost('/picSearch/wes/product-browse-log/getMyFabric', params)
}
// 获取频道详情信息
export const getChanelShow = (params) => {
  return http.fetchGet('/picSearch/wes/chanel/getChanelShow', params)
}

// 删除订单
export const delOrder = (params) => {
  return http.fetchGet('/front/member/delOrder', params)
}
// 商品列表
export const getSearch = (params) => {
  return http.fetchGet('/front/goods/search', params)
}
// 快速搜索
export const getQuickSearch = (params) => {
  return http.fetchPost('/picSearch/wes/product/quickSearch', params)
  // return http.fetchGet('/front/goods/quickSearch', params)
}
// export const addConsult = (params) => {
//   return http.fetchPost('/front/goods/addConsult', params)
// }
// 提交咨询
export const add = (params) => {
  return http.fetchPost('/picSearch/wes/consult/add', params)
}

// 用户操作记录
export const recordBehavor = (params) => {
  return http.fetchPost('/picSearch/wes/behavior/create', params)
}

// 发送email给客服
export const sentEmail = (params) => {
  return http.fetchPost('/picSearch/wes/consult/sendEmail', params)
}

// 图片搜索（阿里云图像搜索）
export const picSearch = (params) => {
  return http.fetchPost('/picSearch/wes/picture/search', params)
}

// 提取阿里云以图搜图命中的商品 ID
export const mapImageSearchToProductIds = (response) => {
  const auctions = (response && response.data && response.data.auctions) || []
  return auctions
    .map(item => item.productId)
    .filter(Boolean)
}

export const getHistory = (params) => {
  return http.fetchPost('/picSearch/wes/consult/getHistory', params)
}

export const getByCustomerId = (params) => {
  return http.fetchPost('/picSearch/wes/chanel/getByCustomerId', params)
}

export const getMenuProducts = (params) => {
  return http.fetchPost('/picSearch/wes/menu-product/getList', params)
}
export const getMenuProductsById = (params) => {
  return http.fetchPost('/picSearch/wes/menu-product/getListById', params)
}
export const getDesignMenuProducts = (params) => {
  return http.fetchPost('/picSearch/wes/design-menu-product/getList', params)
}

export const getFrontCover = (params) => {
  return http.fetchGet('/picSearch/wes/front-cover/getList', params)
}

export const getWomenList = (params) => {
  return http.fetchPost('/picSearch/wes/design-menu-product/getWomenList', params)
}
export const getMenuAllProduct = (params) => {
  return http.fetchPost('/picSearch/wes/design-menu-product/getMenuAllProduct', params)
}
export const getSearchAllProduct = (params) => {
  return http.fetchPost('/picSearch/wes/design/getSearchAllProduct', params)
}

export const selectList = (params) => {
  return http.fetchPost('/picSearch/wes/chanel-group/selectList', params)
}
export const getBannerById = (params) => {
  return http.fetchPost('/picSearch/wes/customer/getBannerById', params)
}
export const addFavorite1 = (params) => {
  return http.fetchPost('/picSearch/wes/favorite/addFavorite', params)
}
export const getFavorites = (params) => {
  return http.fetchPost('/picSearch/wes/favorite/getFavoriteList', params)
}
export const getFavoriteSum = (params) => {
  return http.fetchPost('/picSearch/wes/favorite/getFavoriteSum', params)
}
// export const deleteFavorite = (params) => {
//   return http.fetchPost('/picSearch/wes/favorite/deleteFavorite', params)
// }
export const deleteFavoriteGroup = (params) => {
  return http.fetchPost('/picSearch/wes/favorite/deleteFavoriteGroup', params)
}
export const getBannerList = (params) => {
  return http.fetchPost('/picSearch/wes/customer-banner/getBannerList', params)
}
export const selectBannerById = (params) => {
  return http.fetchPost('/picSearch/wes/customer-banner/selectBannerById', params)
}
export const getListByKeys = (params) => {
  return http.fetchPost('/picSearch/wes/product/getListByKeys', params)
}
export const getDesignListByKeys = (params) => {
  return http.fetchPost('/picSearch/wes/decorate/getPage', params)
}
export const getFavoriteListByKeys = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group-product/getListByKeys', params)
}
export const addFavoriteGroup = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group/addFavoriteGroup', params)
}

export const editFavoriteSalePrice = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group-product/editFavoriteSalePrice', params)
}
export const getFavoriteGroup = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group/getFavoriteGroup', params)
}

export const getNavMenuData = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group/getNavMenuData', params)
}
export const getNavMenuDataOrder = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group/getNavMenuDataOrder', params)
}
export const getFabricFavorite = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group/getFabricFavorite', params)
}

export const getShowFavorite = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group/getShowFavorite', params)
}

export const getStyleFavorite = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group/getStyleFavorite', params)
}

export const getFavoriteGroupName = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group/getFavoriteGroupName', params)
}
export const addFavorite = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group-product/addFavorite', params)
}

export const editFavoriteGroup = (params) => {
  return http.fetchPost('/picSearch/wes//favorite-group-product/editFavorite', params)
}

export const editFavoriteListGroup = (params) => {
  return http.fetchPost('/picSearch/wes//favorite-group-product/editFavoriteGroup', params)
}
export const deleteFavorite = (params) => {
  return http.fetchPost('/picSearch/wes//favorite-group-product/deleteFavorite', params)
}

export const delFavorite = (params) => {
  return http.fetchPost('/picSearch/wes//favorite-group-product/delFavorite', params)
}
export const getWelcomeList = (params) => {
  return http.fetchPost('/picSearch/wes/welcome/list', params)
}
export const getDecorate = () => {
  return http.fetchGet('/picSearch/wes/decorate/list')
}
export const getDesignById = (params) => {
  return http.fetchPost('/picSearch/wes/design/getById', params)
}

export const getByDesignId = (params) => {
  return http.fetchPost('/picSearch/wes/design-preload-fabric/getByDesignId', params)
}

export const getTagByProductId = (params) => {
  return http.fetchPost('/picSearch/wes/fabric-tag/list', params)
}

export const addTag = (params) => {
  return http.fetchPost('/picSearch/wes/fabric-tag/add', params)
}

export const addTagCount = (params) => {
  return http.fetchPost('/picSearch/wes/fabric-tag/addTagCount', params)
}

export const deleteTag = (params) => {
  return http.fetchPost('/picSearch/wes/fabric-tag/delete', params)
}

export const getProductJPGSize = (params) => {
  return http.fetchPost('/picSearch/wes/product/getProductJPGSize', params)
}
// 获取展厅收藏分组名称
export const getDomainFavoriteGroupNames = (params) => {
  return http.fetchPost('/picSearch/wes/domain-favorite-group/getFavoriteGroupName', params)
}
// 获取展厅收藏分组详细信息
export const getDomainFavoriteDetails = (params) => {
  return http.fetchPost('/picSearch/wes/domain-favorite-group/getFavoriteGroup', params)
}
// 删除展厅收藏分组
export const delDomainFavoriteGroups = (params) => {
  return http.fetchPost('/picSearch/wes/domain-favorite-group/deleteFavoriteGroup', params)
}
// 创建展厅收藏分组
export const createDomainFavoriteGroups = (params) => {
  return http.fetchPost('/picSearch/wes/domain-favorite-group/addFavoriteGroup', params)
}
// 获取展厅分组中的详细信息
export const getDomainGroupDetails = (params) => {
  return http.fetchPost('/picSearch/wes/domain-favorite-group/getFavoriteGroup', params)
}
// 编辑展厅分组
export const editDomainGroups = (params) => {
  return http.fetchPost('/picSearch/wes/domain-favorite-group-item/editFavoriteGroup', params)
}

// 获取款式收藏分组名称
export const getStyleFavoriteGroupNames = (params) => {
  return http.fetchPost('/picSearch/wes/design-favorite-group/getFavoriteGroupName', params)
}
// 获取款式收藏分组详细信息
export const getStyleFavoriteDetails = (params) => {
  return http.fetchPost('/picSearch/wes/design-favorite-group/getFavoriteGroup', params)
}
// 删除款式收藏分组
export const delStyleFavoriteGroups = (params) => {
  return http.fetchPost('/picSearch/wes/design-favorite-group/deleteFavoriteGroup', params)
}
// 创建款式收藏分组
export const createStyleFavoriteGroups = (params) => {
  return http.fetchPost('/picSearch/wes/design-favorite-group/addFavoriteGroup', params)
}
// 编辑款式收藏分组
export const editStyleGroups = (params) => {
  return http.fetchPost('/picSearch/wes/design-favorite-group-item/editFavoriteGroup', params)
}

// 添加款式收藏
export const addStyleFavorite = (params) => {
  return http.fetchPost('/picSearch/wes/design-favorite-group-item/addFavorite', params)
}
// 取消款式收藏
export const cancelStyleFavorite = (params) => {
  return http.fetchPost('/picSearch/wes/design-favorite-group-item/delFavorite', params)
}
// 添加展厅收藏
export const addDomainFavorite = (params) => {
  return http.fetchPost('/picSearch/wes/domain-favorite-group-item/addFavorite', params)
}
// 取消展厅收藏
export const cancelDomainFavorite = (params) => {
  return http.fetchPost('/picSearch/wes/domain-favorite-group-item/delFavorite', params)
}

// 获取展厅分组中的详细信息
export const exportExcelWithPic = (params) => {
  return http.fetchPost('/picSearch/wes/consult/exportExcelWithPic', params)
}

// 批量删除收藏面料

export const batchDeleteFabric = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group-product/batchDeleteFabric', params)
}

export const moveGroupToCustomer = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group/moveGroupToCustomer', params)
}
export const batchCopyFabric = (params) => {
  return http.fetchPost('/picSearch/wes/favorite-group-product/batchCopyFabric', params)
}

// ============ Sourcing Fabric Sample API ============

// 获取客户的面料打样需求历史列表（旧接口，已废弃）
export const getSourcingFabricList = (params) => {
  return http.fetchPost('/picSearch/wes/consult/getHistory', params)
}

// 提交面料打样需求（通过 consult 接口，已废弃）
export const submitSourcingFabric = (params) => {
  return http.fetchPost('/picSearch/wes/consult/add', params)
}

// 上传面料样品图片（通用图片上传）
export const uploadSourcingImage = (data) => {
  return http.fetchPost('/picSearch/wes/image/uploadSourceingImage', data)
}

// ============ Sourcing Fabric 独立 API ============

// 创建面料打样需求（新独立接口）
export const createSourcingFabric = (params) => {
  return http.fetchPost('/picSearch/wes/sourcingFabric/create', params)
}

// 按客户ID查询面料打样需求列表（用户端专用）
export const getSourcingFabricListByCustomer = (params) => {
  return http.fetchPost('/picSearch/wes/sourcingFabric/listByCustomer', params)
}

// 删除面料打样需求
export const deleteSourcingFabric = (ids) => {
  return http.fetchPost('/picSearch/wes/sourcingFabric/delete', ids)
}

// 查看面料打样需求详情
export const getSourcingFabricDetail = (id) => {
  return http.fetchGet('/picSearch/wes/sourcingFabric/' + id + '/detail')
}



// WEBPACK FOOTER //
// ./src/api/goods.js